import dataChangeDetector from '../services/dataChangeDetector.js';

/** Defer change notifications to the next microtask (avoids setState-during-render warnings). */
export function scheduleDataChangeTrigger(field, changeType = 'modified') {
  queueMicrotask(() => {
    dataChangeDetector.triggerDataChange(field, changeType);
  });
}
